import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import { getShops } from '../reducers';
import { fetchShops } from '../actions';

// this HOC is a bridge for the transition from redux-based all-at-once admin shops fetching
// to the new react-query-based paginated and granular fetching
// we removed full shop list fetching from the root of the admin app,
// and apply this HOC whenever we still need to consume full users list
export const withLoadAdminShops = compose(
  connect(
    state => ({
      shops: getShops(state),
    }),
    { fetchShops },
  ),
  lifecycle({
    componentDidMount() {
      const wereShopsLoaded = !!this.props.shops && !!this.props.shops.length;
      if (!wereShopsLoaded) {
        this.props.fetchShops();
      }
    },
  }),
);
